import type { FunctionComponent } from "react";
import { DashboardSidebar } from "./dashboard-sidebar.components";
import { DashboardMain } from "./dashboard-main.components";
import { ScrollArea, ScrollBar } from "./ui/scroll-area";

export const DashboardLayout: FunctionComponent = () => {
	return (
		<ScrollArea className="w-full h-screen">
			<div className="flex flex-1 h-full">
				<div className="left-0 z-20 fixed md:flex hidden w-fit h-full">
					<DashboardSidebar />
				</div>
				<div className="md:pl-[256px] w-full h-full">
					<DashboardMain />
				</div>
			</div>
			<ScrollBar className="z-10" orientation="vertical" />
		</ScrollArea>
	);
};
